import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "react-query";
import BrandMetadataSync from "./components/BrandMetadataSync";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import Loading from "./components/Loading";
import { createState } from "./utils/firebaseToState";
import { setMainState } from "./actions/actions";
import { idomDBInstance } from "./axios-notes";
import { parseNoteCheckboxFields } from "./utils/helper";
import Cookies from "js-cookie";
import { redirectUrl, serviceKey, TOKEN_NAME } from "./config";

//Init Store
const store = configureStore();
const queryClient = new QueryClient();

const renderRoot = (content) => ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <BrandMetadataSync />
    {content}
  </QueryClientProvider>,
  document.getElementById("root")
);

let hasRendered = false;
const renderApp = () => {
  if (!hasRendered) {
    renderRoot(
      <Provider store={store}>
        <App />
      </Provider>
    );
    hasRendered = true;
  }
};

//Initial loading page
renderRoot(<Loading />);

const checkAuthAndFetchData = async () => {
  const token = Cookies.get(TOKEN_NAME);
  // console.log(process.env.REACT_APP_REDIRECT_PROD_DOMAIN);
  // console.log(serviceKey);
  if (!token) {
    window.location.href = `${redirectUrl}?pid=${serviceKey}`;
    return;
  }
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await idomDBInstance.get("/notes", { headers });
    const archiveNotesResponse = await idomDBInstance.get(
      "/notes?isArchived=true",
      { headers }
    );
    const trashedNotesResponse = await idomDBInstance.get(
      "/notes?isTrashed=true",
      { headers }
    );

    const constructedData = {
      notes: parseNoteCheckboxFields(response.data.data),
      archive: parseNoteCheckboxFields(archiveNotesResponse.data.data),
      trash: parseNoteCheckboxFields(trashedNotesResponse.data.data),
    };

    const state = createState(constructedData);
    store.dispatch(setMainState(state));
    renderApp();
  } catch (err) {
    console.log(err);
    renderApp();
  }
};

checkAuthAndFetchData();
